var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9345 0 36 8.06555 36 18C36 27.9345 27.9345 36 18 36C8.06555 36 0 27.9345 0 18C0 8.06555 8.06555 0 18 0ZM14.8295 27.5736C22.7948 27.5736 27.15 20.9734 27.15 15.2532C27.15 15.0647 27.15 14.8761 27.141 14.6964C27.9851 14.0858 28.7215 13.3225 29.3051 12.4515C28.5329 12.7927 27.6977 13.0262 26.8177 13.134C27.7157 12.5951 28.3982 11.751 28.7215 10.7364C27.8863 11.2302 26.9614 11.5894 25.9736 11.787C25.1833 10.9429 24.0609 10.4221 22.8127 10.4221C20.424 10.4221 18.4844 12.3617 18.4844 14.7504C18.4844 15.0916 18.5203 15.4238 18.6011 15.7381C15.0002 15.5585 11.8123 13.8344 9.67514 11.2122C9.30691 11.8498 9.09141 12.5951 9.09141 13.3854C9.09141 14.885 9.85472 16.2141 11.0221 16.9863C10.3127 16.9684 9.64814 16.7708 9.06448 16.4476V16.5014C9.06448 18.6027 10.5551 20.3448 12.5397 20.7489C12.1805 20.8477 11.7944 20.9016 11.3993 20.9016C11.1208 20.9016 10.8515 20.8747 10.5821 20.8207C11.1298 22.5449 12.7282 23.7931 14.623 23.829C13.1413 24.9874 11.2736 25.6789 9.24405 25.6789C8.89383 25.6789 8.5526 25.6609 8.21137 25.616C10.1062 26.8552 12.387 27.5736 14.8295 27.5736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.19a9e8bd620ef0da3f19af2f57a6eb1f.svg";
export { ForwardRef as ReactComponent };